export default __webpack_public_path__ + "locales/cs/People.json?hash=691404fb06924efcf65e0612321a750a";